import { useContext } from 'react';

import { TimeseriesChartOverlayRefContext } from '../context/TimeseriesChartOverlayRefContext.js';

export const useTimeseriesOverlayRef = () => {
  const context = useContext(TimeseriesChartOverlayRefContext);

  if (!context) {
    throw new Error(
      '"useTimeseriesOverlayRef" needs to be used under "TimeseriesChartOverlayRefContext"',
    );
  }

  return context;
};
